import React, { useState } from "react";
import "@/styles/pages/loader.scss";

export let startLoader = () => {};
export let endLoader = () => {};

const LoaderWrapper = () => {
  const [loader, setLoader] = useState(false);
  const startProgress = () => {
    setLoader(true);
  };

  const completeProgress = () => {
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  };

  startLoader = startProgress;
  endLoader = completeProgress;

  if (loader) {
    return (
      <div className="loader-wrapper">
        <div className="inforens-loader">
          <img src="/assets/images/Inforens-loader.gif" />
        </div>
      </div>
    );
  }
  return <></>;
};

export default LoaderWrapper;
